import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import classes from './AddMobile.module.css';
import Button from 'components/UI/Button/Button';
import Input from 'components/UI/Input/Input';
import { numberToPhoneNumber } from 'shared/utility';
import { submitProfile } from 'store/thunks';

const AddMobile = () => {
  const { submitted, signedInAs } = useSelector((state) => state.user);
  const [mobileNumber, setMobileNumber] = useState('');
  const [touched, setTouched] = useState(false);
  const history = useHistory();
  const dispatch = useDispatch();

  useEffect(() => {
    // If mobile number is updated, take user to verification screen
    if (submitted) {
      localStorage.setItem('codeSentTo', 'Phone');
      history.push('/verify');
    }
  }, [history, submitted]);

  const inputChangedHandler = useCallback((event) => {
    setMobileNumber(numberToPhoneNumber(event.target.value));
    setTouched(true);
  }, []);

  const submitHandler = useCallback(() => {
    dispatch(
      submitProfile({
        UserId: signedInAs.UserId,
        Phone: mobileNumber.replace(/[^\d]/g, ''),
        // TODO: Verify if profile is created & check if not editing managed profile
        profileCreated: true,
        isManagedUser: false,
      }),
    );
  }, [dispatch, mobileNumber, signedInAs.UserId]);

  const handleCreateProfile = useCallback(() => {
    history.push('/create-profile');
  }, [history]);

  const handleSkip = useCallback(() => {
    localStorage.removeItem('codeSentTo');
    handleCreateProfile();
  }, [handleCreateProfile]);

  const phoneNumberInvalid = mobileNumber.replace(/[^\d]/g, '').length !== 10;
  return (
    <div className={classes.Container}>
      <div className={classes.Header}>
        <FontAwesomeIcon icon="mobile-alt" className={classes.MobileIcon} />
        <h2>Enter Mobile Phone Number</h2>
        <p>A verified phone number makes Riza more secure and easier for members to contact each other.</p>
      </div>
      <div className={classes.Actions}>
        <Input
          elementType="tel"
          value={mobileNumber}
          inputClassName="AuthInput"
          placeholder="Phone number"
          invalid={phoneNumberInvalid}
          shouldValidate={false}
          validationError="please enter a valid phone number"
          touched={touched}
          changed={inputChangedHandler}
          // blurred={false ? (event) => this.props.focusedOut(event) : undefined}
        />
        <Button btnType="AddPhone" clicked={submitHandler} disabled={phoneNumberInvalid}>
          Verify Phone
        </Button>
        <p onClick={handleSkip} className={classes.Skip}>
          Skip this for now and enter Riza
        </p>
      </div>
    </div>
  );
};

export default AddMobile;
